import React, { useState, useEffect } from 'react';
import { Typography, CardActions } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const CustomCard = ({ title, buttons, footer }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const [service, setService] = useState(null);
    const commuteParam = queryParams.get('commute_for');

    useEffect(() => {
        const servicesParam = queryParams.get('services');
        if (servicesParam) {
            setService(servicesParam);
        }
    }, [queryParams]);

    const buttonStyle = {
        background: '#FFC738',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '5px',
        flex: '1',
        maxWidth: '200px',
        minWidth: '150px',
        textAlign: 'center',
        textDecoration: 'none',
    };

    if (commuteParam) {
        navigate(`/?mode=${commuteParam}&services=start`);
    }
    if (service === "looking-for-a-car") {
        navigate('/?step=signup&mode=rider-registration');
    }
    if (service === "offer-your-car") {
        navigate('/?step=signup&mode=driver-registration');
    }

    return (
        <div style={{
            position: 'relative', 
            width: '100%',
            height: '100vh',
            minHeight: '700px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'flex-start',
            paddingTop: '140px',
            justifyContent: 'center',
        }}>
            {/* 1. Background Video using your direct public folder path */}
            <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover', 
                    zIndex: 1
                }}
            >
                <source src="/assets/images/videoo.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            {/* 2. Clear Overlay Tint */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)', 
                zIndex: 2
            }} />

            {/* 3. Overlaid Content */}
            <div style={{
                position: 'relative',
                zIndex: 3,
                width: '100%',
                maxWidth: '800px',
                padding: '0 20px',
                textAlign: 'center',
                marginTop: '130px'
            }}>
                <h3 className="text-center fw-bold mb-4" style={{ color: '#FFFFFF', fontSize: '2.5rem', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                    {title}
                </h3>

                <div className="d-flex align-items-center justify-content-center" style={{ gap: '15px', flexWrap: 'wrap' }}>
                    {buttons.map((button, index) => (
                        <React.Fragment key={index}>
                            <div className="text-center fs-5 fw-bold" style={{ flex: '1', minWidth: '120px' }}>
                                <Link to={button.link} className="btn text-white fw-bold w-100" style={{ ...buttonStyle, minWidth: '100%', padding: '12px' }}>
                                    {button.text}
                                </Link>
                            </div>
                            {index !== buttons.length - 1 && (
                                <div className="fw-bold text-center" style={{ color: '#FFFFFF', fontSize: '1.4rem', padding: '0 10px' }}>
                                    Or
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {footer && (
                    <CardActions className="justify-content-center mt-4" style={{ border: 'none' }}>
                        <Typography sx={{ fontSize: '18px', fontWeight: 'bold', color: '#FFFFFF' }} align="center">
                            {footer}
                        </Typography>
                    </CardActions>
                )}
            </div>
        </div>
    );
};

export default CustomCard;